var __jsx = React.createElement;
import React from 'react';
import Grid from '@mui/material/Grid';
import HeaderWithSidebar from '../HeaderWithSidebar';
import PageHeader from '../../organisms/common/PageHeader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HeaderSidebar1Col = function HeaderSidebar1Col(_ref) {
  var children = _ref.children,
    title = _ref.title,
    icon = _ref.icon;
  return /*#__PURE__*/_jsxs(HeaderWithSidebar, {
    children: [title && /*#__PURE__*/_jsx(PageHeader, {
      title: title,
      icon: icon
    }), /*#__PURE__*/_jsx(Grid, {
      container: true,
      children: /*#__PURE__*/_jsx(Grid, {
        item: true,
        lg: 12,
        md: 12,
        sm: 12,
        children: children
      })
    })]
  });
};
HeaderSidebar1Col.defaultProps = {
  title: null,
  icon: undefined
};
export default HeaderSidebar1Col;